import { Component, Input, OnInit } from '@angular/core';

// general alert for all users - shown in home, add-site and contact pages
export const GENERAL_ALERT_TEXT = "בימי חול המועד אנא שלחו בקשות דחופות בלבד, שהן בגדר ״דבר האבד״ והכרחיות לצורך פרנסה.\nבקשות שאינן עומדות בתנאים אלו, יש לשלוח לאחר החג.\nחג שמח!"

@Component({
  selector: 'app-general-alert',
  templateUrl: './general-alert.component.html',
  styleUrls: ['./general-alert.component.scss']
})
export class GeneralAlertComponent implements OnInit {
  @Input() page = ''; // 'add-site' | 'contact' - aligns the popup to the page content column
  alertText = GENERAL_ALERT_TEXT;
  isShow = false;

  ngOnInit(): void {
    if (!this.alertText) return;
    // same storage keys as home page general alert (separate from the 019 alert keys) - closing 3 times hides it everywhere
    const alertContentStorage = localStorage.getItem('general-alert-content')
    if (alertContentStorage !== this.alertText) {
      this.isShow = true;
    }
    else if (localStorage.getItem('general-alert')) {
      const showAlertStorage = parseInt(localStorage.getItem('general-alert'))
      this.isShow = showAlertStorage < 3
    }
    else {
      this.isShow = true;
    }
  }

  close() {
    this.isShow = false;
    const alertContentStorage = localStorage.getItem('general-alert-content')
    if (alertContentStorage === this.alertText && localStorage.getItem('general-alert')) {
      let showAlertStorage = parseInt(localStorage.getItem('general-alert'))
      localStorage.setItem('general-alert', (showAlertStorage += 1).toString());
    }
    else {
      localStorage.setItem('general-alert', "1");
      localStorage.setItem('general-alert-content', this.alertText);
    }
  }
}
